<template>
  <el-dialog
    title="批量导入游戏"
    :visible="isVisible"
    width="500px"
    :close-on-click-modal="false"
    class="page-dialog"
    @closed="handleDialogClosed"
    @close="handleCancel"
  >
    <div class="import-container">
      <el-upload
        class="upload-demo"
        action="#"
        :on-change="handleFileChange"
        :before-upload="beforeUpload"
        :auto-upload="false"
        :file-list="fileList"
        :limit="1"
        :on-exceed="handleExceed"
        drag
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">
          将文件拖到此处，或 <em>点击上传</em>
        </div>
        <div slot="tip" class="el-upload__tip">
          支持 xlsx、xlsm 格式的文件，单个文件大小不超过 10M
        </div>
      </el-upload>

      <div class="template-download" style="margin-top: 20px">
        <el-button size="small" @click="handleDownloadTemplate">下载游戏模板</el-button>
      </div>
    </div>

    <template slot="footer">
      <el-button size="small" @click="handleCancel">取消</el-button>
      <el-button type="primary" size="small" :loading="loading" :disabled="fileList.length === 0" @click="handleConfirm">确定</el-button>
    </template>
  </el-dialog>
</template>

<script>
import { uploadGameExcel, getGameExcelTemplate } from '@/api/gameManage/gameList.js'
import { uploadToS3 } from '@/api/upload.js'
import XLSX from 'xlsx'

export default {
  name: 'ManageGameImportDialog',
  props: {
    isVisible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      fileList: [],
      loading: false
    }
  },
  methods: {
    handleDialogClosed() {
      this.fileList = []
      this.loading = false
    },

    handleCancel() {
      this.$emit('close')
    },

    handleFileChange(file, fileList) {
      this.fileList = fileList
    },

    handleExceed(files, fileList) {
      this.$message.warning('只能上传一个文件')
    },

    beforeUpload(file) {
      const isExcel = /\.(xlsx|xlsm)$/i.test(file.name)
      const isLt10M = file.size / 1024 / 1024 < 10

      if (!isExcel) {
        this.$message.error('只能上传 xlsx、xlsm 格式的文件')
        return false
      }
      if (!isLt10M) {
        this.$message.error('上传文件大小不能超过 10MB')
        return false
      }

      return true
    },

    async handleDownloadTemplate() {
      try {
        this.loading = true
        const response = await getGameExcelTemplate({})
        if (response.code === 0) {
          const headers = response.data.headers

          // 创建工作簿
          const wb = XLSX.utils.book_new()

          // 创建工作表数据
          const wsData = [headers]

          // 创建工作表
          const ws = XLSX.utils.aoa_to_sheet(wsData)

          // 将工作表添加到工作簿
          XLSX.utils.book_append_sheet(wb, ws, '游戏模板')

          // 生成Excel文件并下载
          XLSX.writeFile(wb, '游戏模板.xlsx')

          this.$message.success('模板下载成功')
        } else {
          this.$message.error('模板下载失败：' + (response.msg || '未知错误'))
        }
      } catch (error) {
        this.$message.error('模板下载失败：' + error.message)
        console.error('模板下载失败:', error)
      } finally {
        this.loading = false
      }
    },

    async handleConfirm() {
      if (this.fileList.length === 0) {
        this.$message.warning('请选择要导入的文件')
        return
      }

      try {
        this.loading = true
        const file = this.fileList[0].raw

        // 上传Excel文件到S3
        const uploadResult = await uploadToS3(file)
        if (!uploadResult.success) {
          this.$message.error('文件上传失败：' + uploadResult.error)
          return
        }

        // 调用导入接口
        const response = await uploadGameExcel({
          file_url: uploadResult.data.objectUrl
        })

        if (response.code === 0) {
          this.$message.success('游戏批量导入成功')
          this.$emit('import-success')
          this.$emit('close')
        } else {
          this.$message.error('游戏批量导入失败：' + (response.msg || '未知错误'))
        }
      } catch (error) {
        this.$message.error('游戏批量导入失败：' + error.message)
        console.error('游戏批量导入失败:', error)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.import-container {
  padding: 20px 0;
}

.template-download {
  margin-top: 20px;
}
</style>
